import { connect } from 'react-redux';

import { DistributorContextValue } from '@mews-distributor/common';

import { getCurrentValidAvailabilityBlockName } from '../../../selectors/views/availabilityBlocks';
import { ApplicationState } from '../../../types';

interface StateProps {
    subtitle: string | null;
}

export const inject = connect<StateProps, {}, DistributorContextValue, ApplicationState>(
    (state, { appClockService }) => {
        const nowUtc = appClockService.getAppNowUtc();
        const subtitle = getCurrentValidAvailabilityBlockName(state, { nowUtc });

        return {
            subtitle,
        };
    }
);
